import React from 'react';
import { Select, Spin, Button, Icon, Modal, Form, Row, Col } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CatalogosRequest from '../../services/Catalogos';
import CategoriasRequest from '../../services/Categorias';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;
const { confirm } = Modal;

/**
 * Clase para ver el proceso de formulario de categorizar
 */
class FormCalendario extends BaseComponent {
    state = {
        arrDiasSemana: [],
        cargando: false,
        bloquearBotones: false,
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if (this.props.categoria_selected !== prevProps.categoria_selected) {
            if (this.props.tipo_modal === 'dos') {
                this.setState({ cargando: true, bloquearBotones: true }, () => {
                    CatalogosRequest.ListarDiasPedido()
                        .then(response => {
                            state.arrDiasSemana = response.data
                            state.cargando = false;
                            state.bloquearBotones = false
                            this.setState(state)
                        })
                        .catch(err => {
                            openNotification(
                                "Ha ocurrido un error al listar las categorías.",
                                "Error al listar categorías",
                                false
                            )
                        })
                })
            }
        }
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.esconderModal(false);
        this.setState({ bloquearBotones: false })
    }

    /**
     * Comportamiento al confirmar editar calendario
     * @param: nada.
     * @return: nada.
     */
    showConfirm = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    title: 'Confirmar',
                    content: <div><b>¿Está seguro de editar el calendario de la categoría?</b> Se cambiará la información de la categoría.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-confirmacion-editar-calendario-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-confirmacion-editar-calendario-form',
                    },
                    onOk: () => {
                        this.handleSubmit()
                    },
                });
            }
        })

    }

    /**
     * Comportamiento al confirmar categorización
     * @param: nada.
     * @return: nada.
     */
    handleSubmit = () => {
        let state = { ...this.state }
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ cargando: true, bloquearBotones: true }, () => {
                    CategoriasRequest.EditarCategoriaCalendario(this.props.categoria_selected.id, values)
                        .then(response => {
                            state.cargando = false
                            state.bloquearBotones = false
                            this.setState(state)
                            this.props.form.resetFields();
                            this.props.esconderModal(true);
                            openNotification(
                                "Se ha editado el registro correctamente.",
                                "Registro editado correctamente",
                                true
                            )
                        })
                        .catch(err => {
                            openNotification(
                                "Ha ocurrido un error al editar el registro.",
                                "Error al editar registro",
                                false
                            )
                            this.setState({cargando: false, bloquearBotones: false})
                        })
                })
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Modal
                    title={(this.props.categoria_selected !== undefined && this.props.categoria_selected !== null) ? this.props.modo !== "ver" ? `Editar calendario de la categoría ${this.props.categoria_selected.categoria_nombre}` : `Ver calendario de la categoría ${this.props.categoria_selected.categoria_nombre}` : ''}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.showConfirm}
                    width={this.state.isPos ? "85%" : "35%"}
                    maskClosable={false}
                    confirmLoading={true}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-calendario-categoria-form"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo === 'ver' ? 'display-none' : ''}
                                key="submit"
                                id="boton-guardar-calendario-categoria-form"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={24}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Días de pedido" : <b>Días de pedido</b>}
                                        colon={this.props.modo !== "ver" ? true : false}>
                                        {getFieldDecorator('dias_pedido', {
                                            rules: [
                                                { required: this.props.modo !== "ver" ? true : false, message: 'Por favor, seleccione días de pedido.' },
                                            ],
                                            initialValue: (
                                                (this.props.categoria_selected !== undefined && this.props.categoria_selected !== null) ? this.props.categoria_selected.dias_pedido.map(item => item.id) : null
                                            )
                                        })(
                                            <Select
                                                allowClear
                                                style={{ width: '100%' }}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                showSearch
                                                maxLength={100}
                                                showArrow={this.props.modo !== "ver" ? true : false}
                                                id="select-elegir-dias-pedido-calendario-form"
                                                defaultActiveFirstOption={false}
                                                optionFilterProp="children"
                                                mode="multiple"
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                disabled={this.props.modo !== "ver" ? false : true}
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrDiasSemana.length > 0 &&
                                                    this.state.arrDiasSemana.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}>
                                                                {obj.descripcion}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div >
        )
    }
}

export default Form.create()(FormCalendario);